import {addToastMessage} from "../stores/MessageStore";
import {MessageSeverity} from "../utils/MessageSnackbar";

export const shortenUrl = async (url: string) => {
  const response = await fetch(
    `https://s0na.de`,
    {
      method: 'POST',
      body: JSON.stringify({url})
    })
  if (!response.ok) {
    addToastMessage('Failed to shorten url', MessageSeverity.error)
    console.error(`Failed to shorten url ${url}`, {error: response})
    throw new Error(`Failed to shortend url ${url}`)
  }
  const parsed = await response.json()
  return parsed as ShortenUrlResponse
}

export const getInfoByEditKey = async (editKey: string) => {
  const response = await fetch(`https://s0na.de/info/${editKey}`)
  if (!response.ok) {
    console.error(`Failed to get info for editKey ${editKey}`, {error: response})
    throw new Error(`Failed to get info for editKey ${editKey}`)
  }
  const parsed = await response.json()
  return parsed as UrlInfo
}

export const editUrl = async ({editKey, newUrl}: EditUrlRequest) => {
  const response = await fetch(
    'https://s0na.de',
    {
      method: 'PUT',
      body: JSON.stringify({
        editKey,
        url: newUrl,
      })
    }
  )
  if (!response.ok) {
    addToastMessage('Failed to edit url', MessageSeverity.error)
    console.error(`Failed to edit url for key ${editKey}`, {error: response})
    throw new Error(`Failed to edit url for key ${editKey}`)
  }
}

export const deleteUrl = async (editKey: string) => {
  const response = await fetch(`https://s0na.de/${editKey}`, {method: 'DELETE'})
  if (!response.ok) {
    addToastMessage('Failed to delete url', MessageSeverity.error)
    console.error(`Failed to delete url for key ${editKey}`, {error: response})
    throw new Error(`Failed to delete url for key ${editKey}`)
  }
}

export type UrlInfo = {
  url: string
  key: string
}

export type EditUrlRequest = {
  editKey: string
  newUrl: string
}

export type ShortenUrlResponse = {
  key: string
  editKey: string
  url: string
  editUrl: string
}